import Vue from 'vue'
import Router from 'vue-router'

// 懒加载页面组件
const Home = () => import('../views/Home.vue')
const Products = () => import('../views/Products.vue')
const Solutions = () => import('../views/Solutions.vue')
const About = () => import('../views/About.vue')
const Contact = () => import('../views/Contact.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页 - 智控安防解决方案',
        description: '智控安防解决方案首页，专业从事智能管控设备的研发、生产、销售，为客户提供智能车载柜、智能便携箱、野战智能兵器库、岗哨智能管理系统等产品和全方位的安防解决方案。',
        keywords: '智控安防,智能管控设备,安防解决方案,智能车载柜,智能便携箱,野战智能兵器库,岗哨智能管理系统'
      }
    },
    {
      path: '/products',
      name: 'Products',
      component: Products,
      meta: {
        title: '产品中心 - 智控安防解决方案',
        description: '智控安防产品中心，展示智能车载柜、智能便携箱、野战智能兵器库、岗哨智能管理系统等智能管控设备产品，所有产品均经过严格质量控制，确保高稳定性和可靠性。',
        keywords: '产品中心,智能车载柜,智能便携箱,野战智能兵器库,岗哨智能管理系统,智能管控设备,安防设备'
      }
    },
    {
      path: '/products/detail',
      name: 'ProductsDetail',
      component: () => import('../views/products/index.vue'),
      meta: {
        title: '产品详情 - 智控安防解决方案',
        description: '智控安防产品详细信息，了解各智能管控设备的技术参数、功能特点和应用场景，为您的安防需求提供专业产品参考。',
        keywords: '产品详情,智能管控设备详情,安防产品技术参数,智能车载柜详情,智能便携箱详情'
      }
    },
    {
      path: '/solutions',
      name: 'Solutions',
      component: Solutions,
      meta: {
        title: '解决方案 - 智控安防解决方案',
        description: '智控安防专业解决方案，针对不同行业和场景提供定制化的智能管控系统解决方案，包括安防监控、智能管理、安全防护等全方位服务。',
        keywords: '解决方案,安防解决方案,智能管控系统,行业解决方案,安防监控,安全防护,智能管理系统'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: '关于我们 - 智控安防解决方案',
        description: '广东华南智控科技有限公司成立于2020年，是一家集研发、生产、销售、服务为一体的涉密安防、智能管控系统研发服务商，拥有专业的研发团队和完善的售后服务体系。',
        keywords: '关于我们,广东华南智控科技,企业简介,公司发展,研发团队,企业文化,安防企业'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: '联系我们 - 智控安防解决方案',
        description: '联系智控安防，了解更多智能管控设备产品和解决方案，专业的客服团队为您提供咨询、技术支持和售后服务，期待与您的合作。',
        keywords: '联系我们,联系方式,电话,邮箱,地址,技术支持,售后服务,在线咨询'
      }
    },
    {
      // 捕获所有未匹配的路由，重定向到首页
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 路由前置守卫，动态设置页面标题和SEO相关信息
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }
  
  // 设置页面描述（如果路由中定义了）
  const description = to.meta.description || '智控安防解决方案-专业从事智能管控设备的研发、生产、销售，提供智能车载柜、智能便携箱、野战智能兵器库、岗哨智能管理系统等产品';
  let metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', description);
  }
  
  // 设置页面关键词（如果路由中定义了）
  const keywords = to.meta.keywords || '智控安防,智能管控设备,智能车载柜,智能便携箱,野战智能兵器库,岗哨智能管理系统,安防设备,智能安防';
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (metaKeywords) {
    metaKeywords.setAttribute('content', keywords);
  }
  
  // 继续执行路由
  next()
})

export default router